export default __webpack_public_path__ + "static/media/futura.0419689f.woff";